<template>
  <div>
    <TitleWithBackButton title="" back-route="Settings" icon="mdi-graphql"></TitleWithBackButton>
    <v-container>
      <h2 class="text-left">Configurazione Iva</h2>
      <v-row v-if="!!this.viewBar.active">
        <v-card
          class=""
          flat
          color="transparent"
        >
          <v-card-title class="pb-0">{{translator('taxForBar')}}</v-card-title>
          <v-card-text class="text-left d-flex">
            <v-autocomplete
              filled
              hide-details="auto"
              dense
              v-model="taxForBar"
              :items="[
                {text: '0%', value: 0},
                {text: '5%', value: 5},
                {text: '10%', value: 10},
                {text: '22%', value: 22},
              ]"
              @input="handleTaxForBarInput"
            ></v-autocomplete>
          </v-card-text>
        </v-card>
      </v-row>
      <v-row>
        <v-card
          class=""
          flat
          color="transparent"
        >
          <v-card-title class="pb-0">{{translator('taxForSaloon')}}</v-card-title>
          <v-card-text class="text-left d-flex">
            <v-autocomplete
              filled
              hide-details="auto"
              dense
              v-model="taxForSaloon"
              :items="[
                {text: '0%', value: 0},
                {text: '5%', value: 5},
                {text: '10%', value: 10},
                {text: '22%', value: 22},
              ]"
              @input="handleTaxForSaloonInput"
            ></v-autocomplete>
          </v-card-text>
        </v-card>
      </v-row>
      <v-divider class="mt-5 mb-3"></v-divider>
      <h2 class="text-left">Colori</h2>
      <v-row>
        <v-card
          class=""
          flat
          color="transparent"
        >
          <v-card-title class="pb-0">{{$translations.t('settings.colorizeServiceSelector.title')}}</v-card-title>
          <v-card-text class="text-left d-flex">
            <BooleanSetting
              :value="colorizeServiceSelector"
              settingKey="colorizeServiceSelector"
              @set="setSetting"
            ></BooleanSetting>
            <div class="pb-2">{{$translations.t('settings.colorizeServiceSelector.description')}}</div>
          </v-card-text>
        </v-card>
      </v-row>
      <v-row>
        <v-card
          class=""
          flat
          color="transparent"
        >
          <v-card-title class="pb-0">{{$translations.t('settings.colorizeOperatorSelector.title')}}</v-card-title>
          <v-card-text class="text-left d-flex">
            <BooleanSetting
              :value="colorizeOperatorSelector"
              settingKey="colorizeOperatorSelector"
              @set="setSetting"
            ></BooleanSetting>
            <div class="pb-2">{{$translations.t('settings.colorizeOperatorSelector.description')}}</div>
          </v-card-text>
        </v-card>
      </v-row>
      <v-divider class="mt-5 mb-3"></v-divider>      
      <h2 class="text-left">Pagamenti</h2>
      <v-row>
        <v-card
          class=""
          flat
          color="transparent"
        >
          <v-card-title class="pb-0">{{$translations.t('settings.checkCustomerGdpr.title')}}</v-card-title>
          <v-card-text class="text-left d-flex">
            <BooleanSetting
              :value="checkCustomerGdpr"
              settingKey="checkCustomerGdpr"
              @set="setSetting"
            ></BooleanSetting>
            <div class="pb-2">{{$translations.t('settings.checkCustomerGdpr.description')}}</div>
          </v-card-text>
        </v-card>
      </v-row>
      <v-divider class="mt-5 mb-3"></v-divider>
      <h2 class="text-left">Accesso</h2>
      <v-row>
        <v-card
          class=""
          flat
          color="transparent"
        >
          <v-card-title class="pb-0">{{$translations.t('settings.confirmLogout.title')}}</v-card-title>
          <v-card-text class="text-left d-flex">
            <BooleanSetting
              :value="confirmLogout"
              settingKey="confirmLogout"
              @set="setSetting"
            ></BooleanSetting>
            <div class="pb-2">{{$translations.t('settings.confirmLogout.description')}}</div>
          </v-card-text>
        </v-card>
      </v-row>
      <v-divider class="mt-5 mb-3"></v-divider>
      <h2 class="text-left">Timbrature</h2>
      <v-row>
        <v-card
          class=""
          flat
          color="transparent"
        >
          <v-card-title class="pb-0">{{$translations.t('settings.checkTimelogBarcode.title')}}</v-card-title>
          <v-card-text class="text-left d-flex">
            <BooleanSetting
              :value="checkTimelogBarcode"
              settingKey="checkTimelogBarcode"
              @set="setSetting"
            ></BooleanSetting>
            <div class="pb-2">{{$translations.t('settings.checkTimelogBarcode.description')}}</div>
          </v-card-text>
        </v-card>
      </v-row>
      <v-divider class="mt-5 mb-3"></v-divider>
      <h2 class="text-left">Stampante</h2>
      <v-row>
        <v-card flat color="transparent">
          <v-card-title class="pb-0">{{
            $translations.t("settings.emulateRtPrinter.title")
          }}</v-card-title>
          <v-card-text class="text-left">
            <div class="pb-2">
              {{ $translations.t("settings.emulateRtPrinter.description") }}
            </div>
            <v-switch
              class="pa-0 ma-0"
              hide-details="auto"
              v-model="emulateRtPrinter"
              @change="setSetting('emulateRtPrinter', $event)"
            ></v-switch>
          </v-card-text>
        </v-card>
      </v-row>
      <v-divider class="mt-5 mb-3"></v-divider>
    </v-container>
  </div>
</template>

<script>
import * as components from "../generalSettingComponents";
import TitleWithBackButton from '@/components/common/TitleWithBackButton.vue';

export default {
  name: "ControlPanel",
  components: { 
    ...components,
    TitleWithBackButton
  },
  data: function () {
    return {
      taxForBar: undefined,
      taxForSaloon: undefined,
      colorizeServiceSelector: undefined,
      colorizeOperatorSelector: undefined,
      weeklyReminder: undefined,
      showPromoNewCustomer: undefined,
      showPromoCustomer: undefined,
      showPromoMinorCustomer: undefined,
      automaticBirthdayMessage: undefined,
      checkCustomerGdpr: undefined,
      confirmLogout: undefined,
      dailyReminder: undefined,
      goalsDailyReminder: undefined,
      goalsWeeklyReminder: undefined,
      automaticReminderMarketingEvent: undefined,
      checkTimelogBarcode: undefined,
      viewBar: undefined,
      viewMarketingCalendar: undefined,
      viewGoals: undefined,
      emulateRtPrinter: undefined
    };
  },
  methods: {
    translator(settingKey) {
      return this.$translations.t("settings." + settingKey + ".title");
    },
    handleTaxForBarInput(value) {
      this.setSetting('taxForBar', value)
    },
    handleTaxForSaloonInput(value) {
      this.setSetting('taxForSaloon', value)
    },
    setSetting(key, value) {
      this.$settings.set(key, value)
    }
  },
  settings: {
    taxForBar: {
      bind: "taxForBar",
    },
    taxForSaloon: {
      bind: "taxForSaloon",
    },
    weeklyReminder: {
      bind: "weeklyReminder"
    },
    dailyReminder: {
      bind: "dailyReminder"
    },
    colorizeServiceSelector: {
      bind: "colorizeServiceSelector"
    },
    colorizeOperatorSelector: {
      bind: "colorizeOperatorSelector"
    },
    showPromoCustomer: {
      bind: "showPromoCustomer"
    },
    showPromoNewCustomer: {
      bind: "showPromoNewCustomer"
    },
    showPromoMinorCustomer: {
      bind: "showPromoMinorCustomer"
    },
    automaticBirthdayMessage: {
      bind: "automaticBirthdayMessage"
    },
    checkCustomerGdpr: {
      bind: "checkCustomerGdpr"
    },
    confirmLogout: {
      bind: "confirmLogout"
    },
    goalsDailyReminder: {
      bind: "goalsDailyReminder"
    },
    goalsWeeklyReminder: {
      bind: "goalsWeeklyReminder"
    },
    automaticReminderMarketingEvent: {
      bind: "automaticReminderMarketingEvent"
    },
    checkTimelogBarcode: {
      bind: "checkTimelogBarcode"
    },
    emulateRtPrinter: {
      bind: "emulateRtPrinter"
    }
  },
  licenseSettings: {
    viewBar: {
      bind: "viewBar"
    },
    viewMarketingCalendar: {
      bind: "viewMarketingCalendar"
    },
    viewGoals: {
      bind: "viewGoals"
    },
  }
};
</script>

<style>
</style>